import { Card, CardBody, Col, Container, Row } from "reactstrap";
import { Breadcrumbs } from "../../../../../AbstractElements";
import { FormControlsTitle, InputMaskTitle } from "../../../../../Constants/Constants";
import { InputMasksSubTitle } from "../../../../../Data/Forms&Table/Forms/FormControls";
import CommonCardHeader from "../../../../CommonComponents/CommonCardHeader/CommonCardHeader";
import DateFormat from "./DateFormat";
import DefaultInputMask from "./DefaultInputMask";
import TimeFormat from "./TimeFormat";

const InputMaskContainer = () => {
  return (
    <>
    <Breadcrumbs mainTitle={InputMaskTitle} parent={FormControlsTitle}/>
    <Container fluid>
      <Row>
        <Col xs="12">
          <Card>
            <CommonCardHeader title={InputMaskTitle} span={InputMasksSubTitle} />
            <CardBody className="input-mask">
              <Row className="g-3">
                <DateFormat />
                <TimeFormat />
                <DefaultInputMask />
              </Row>
            </CardBody>
          </Card>
        </Col>
      </Row>
    </Container>
    </>
  );
};
export default InputMaskContainer;
